export const fullName = (user)=>{
    var _ref, _ref1;
    return [
        (_ref = user === null || user === void 0 ? void 0 : user.firstName) !== null && _ref !== void 0 ? _ref : '',
        (_ref1 = user === null || user === void 0 ? void 0 : user.lastName) !== null && _ref1 !== void 0 ? _ref1 : ''
    ].join(' ').trim();
};
